import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { MsalProvider } from '@azure/msal-react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { router } from './routes';
import { initializeMsal, msalInstance } from './auth/msal.config';
import './index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Der Kalender muss aktuell sein: Wer einen freien Slot sieht, der längst
      // belegt ist, bekommt beim Buchen einen 409 und ärgert sich zu Recht.
      staleTime: 15_000,
      refetchOnWindowFocus: true,
      retry: 1,
    },
  },
});

const container = document.getElementById('root');
if (!container) throw new Error('Wurzelelement #root nicht gefunden');

/**
 * MSAL wird vor dem ersten Render initialisiert.
 *
 * Das ist keine Kosmetik: `handleRedirectPromise()` muss laufen, bevor
 * Komponenten den Anmeldezustand abfragen — sonst zeigt die Oberfläche nach der
 * Rückkehr vom Anmeldedialog kurz „nicht angemeldet" und löst womöglich eine
 * zweite Anmeldung aus.
 */
void initializeMsal()
  .catch((error: unknown) => {
    console.error('MSAL konnte nicht initialisiert werden:', error);
  })
  .finally(() => {
    createRoot(container).render(
      <StrictMode>
        <MsalProvider instance={msalInstance}>
          <QueryClientProvider client={queryClient}>
            <RouterProvider router={router} />
          </QueryClientProvider>
        </MsalProvider>
      </StrictMode>,
    );
  });
